import React  from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IconBuilding } from '../../../Assets/contacts/IconBuilding';
import { Dictionery } from '../../../Data/Dictionery';

const Styles = styled(Link)`
    flex-grow: 1;
    min-width: 180px;
    min-height: 180px;
    margin: 1px 0 0;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
    position: relative;
    border-radius: var(--border-radius-3);
    background-color: var(--n-grey-0);
    text-decoration: none;
    color: inherit;
    /* border: 1px solid; */
    /* border-image-source: linear-gradient(180deg, #E5E5E5 0%, rgba(229, 229, 229, 0) 100%); */
    &::before {
        content: "";
        z-index: -1;
        position: absolute;
        inset: -1px;
        background: linear-gradient(180deg, #E5E5E5 0%, #E5E5E500 100%);
        border-radius: calc(var(--border-radius-3) + 1px);
    }
    box-shadow: 0px 23px 40px -13px #00000014;
    .back-top {
      width: 100%;
      aspect-ratio: 1.8;
      overflow: hidden;
      border-radius: var(--border-radius-3);
      background-color: var(--n-grey-0);
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
    }
    .image {
        margin-top: calc(-90px - 1rem);
        width: 150px;
        height: 150px;
        overflow: hidden;
        display: flex;
        align-self: center;
        border-radius: 100px;
        background-color: var(--n-grey-0);
        border: 1px solid var(--n-grey-11);
        img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }
    }
    .data {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .title {
            text-align: center;
            font-weight: 700;
            font-size: 1.25rem;
        }
        .line {
          height: 1px;
          background-color: var(--n-grey-1);
        }
        .desc {
          display: flex;
          gap: 0.5rem;
          justify-content: space-between;
          align-items: center;
          font-size: 0.9rem;
          font-weight: 600;
        }
    }
`
export default function AgencyCart (props){
  const {v, i, lan="en"} = props;
  return (
    <Styles key={i} to={"/" + lan.filename + "/travel-agency/" + v.Agency_Id}>
      <div className='back-top'>
        {
            (v.Agency_Picture) ? (
                <img src={v.Agency_Picture} alt={v.Agency_Name}/>
            ) : ""
        }
      </div>
      <div className='image'>
        {
            (v.Agency_Logo) ? (
                <img src={v.Agency_Logo} alt={v.Agency_Name}/>
            ) : ""
        }
      </div>
      <div className='data'>
        <div className='title'>
            {v.Agency_Name}
        </div>
        <div className='line'></div>
        <div className='desc'>
          <div className='base'>
            {Dictionery.nowTours[lan.filename]}:
          </div>
          <div className='value'>
            0 {Dictionery.Tour[lan.filename]}
          </div>
        </div>
      </div>
    </Styles>
  )
}

